import { UseQueryResult } from '@tanstack/react-query';

function isPendingOrError(query: UseQueryResult, enabled = true) {
    return enabled ? !query.isSuccess : false;
}

export const Query = {
    isPendingOrError,
};
